import { flow, filter, toPairs, map, identity } from 'lodash/fp';

export default (decodeKey = identity) =>
  flow(
    toPairs,
    filter(([, value]) => value),
    map(([key]) => decodeKey(key)),
  );
